import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class TableLayoutService {

    static addTableLayout = data => {
        return axios.post(PATH.ADD_TABLE_LAYOUT, data);
    }

    static getTableLayoutList = params => {
        return axios.get(PATH.GET_TABLE_LAYOUT_LIST, {params});
    }

    static getTableLayoutListByOwner = params => {
        return axios.get(PATH.GET_TABLE_LAYOUT_LIST_BY_OWNER, {params});
    }

    static getTableLayoutById = id => {
        return axios.get(`${PATH.GET_TABLE_LAYOUT_BY_ID}/${id}`);
    }

    static deleteTableLayout = id => {
        return axios.delete(`${PATH.DELETE_TABLE_LAYOUT}/${id}`);
    }

    static editTableLayout = (id, data) => {
        return axios.put(`${PATH.EDIT_TABLE_LAYOUT}/${id}`, data);
    }

}
